module.exports = __webpack_public_path__ + "public/SiteImages/loginBanner.png?690c4009";